export default {"id":"icon-logo-black"}